export const getUrl = () => {
  return process.env.REACT_APP_WS_HOST
};